<template>
	<v-app-bar
		class="px-0 appBar"
		id="app-bar"
		absolute
		app
		flat
		:style="{ 'border-bottom': smallAppBar ? '1px solid #e1dce8' : 'none' }"
		:height="smallAppBar ? 60 : 115">
		<v-row>
			<v-col class="d-flex align-center justify-start" cols="5">
				<v-btn small plain color="white" elevation="0" class="ml-n2" @click="setDrawer(!drawer)">
					<v-icon color="black">mdi-menu</v-icon>
				</v-btn>
				<span class="ml-3 font-size18 font-weight-bold">{{ $t(pathname) }}</span>
			</v-col>
			<v-col cols="7" class="d-flex align-center justify-end">
				<v-menu offset-y transition="scale-transition" max-width="175" z-index="101">
					<template #activator="{ attrs, on }">
						<v-btn color="white" v-bind="attrs" v-on="on" class="elevation-0">
							<img :src="getImageForRole" class="app-bar-settings-icon mr-1" />
							<span>{{ userFullName }}</span>
						</v-btn>
					</template>

					<v-list :tile="false" nav dense>
						<template>
							<v-list-item-group v-for="(item, i) in userMenu" :key="i">
								<v-list-item dense v-if="!item.divider" class="background-white" @click="redirect(item)">
									<v-list-item-icon>
										<v-icon color="black">{{ item.icon }}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title class="d-flex align-left pl-0 pt-1">{{ item.text }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list-item-group>
						</template>
					</v-list>
				</v-menu>
			</v-col>
			<app-bar-filter v-if="!smallAppBar" />
		</v-row>
	</v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { profileSettingsBlack, doctorBlack, nurseBlack } from '@/assets/index';
// import ProfileDialog from '../dialogs/ProfileDialog.vue';
import AppBarFilter from './AppBarFilters.vue';

export default {
	name: 'DashboardCoreAppBar',
	components: {
		// ProfileDialog,
		AppBarFilter,
	},
	data: () => ({
		chosenUnit: 'metric',
		chosenGCh: 'mmol',
		profileSettingsBlack: profileSettingsBlack,
		doctorBlack: doctorBlack,
		nurseBlack: nurseBlack,
		pccMenu: false,
	}),
	computed: {
		...mapGetters({ roleName: 'authentication/getRole', userFullName: 'authentication/getFullName' }),
		// ...mapState(['drawer'])
		...mapState({
			drawer: (state) => state.drawer,
			detailedUser: (state) => state.users.detailedUser,
			authUser: (state) => state.authentication.userData,
			startTimeTrackingInfo: (state) => state.timetracking.startTimeTrackingInfo,
			rateLimits: (state) => state.pcc.rateLimits,
		}),
		smallAppBar () {
			return (
				this.pathname === 'Dashboard' ||
				this.pathname === 'Patient Details' ||
				this.pathname === 'Release Notes and Manuals' ||
				this.pathname === 'Terra Patient Integration' ||
				this.pathname === 'Schedules Reports' ||
				this.pathname === 'Tablets' ||
				(this.pathname === 'Mapping Patients' && !this.roleIsSystemAdmin) ||
				(this.pathname === 'Mapping Medical Staff' && !this.roleIsSystemAdmin) ||
				this.pathname === 'PointClickCare Patient Mapping'
			);
		},
		roleIsHospitalAdmin () {
			return this.roleName === 'HOSPITAL_ADMIN';
		},
		roleIsSystemAdmin () {
			return this.roleName === 'SYSTEM_ADMIN' || this.roleName === 'SYSTEM_USER';
		},
		pathname () {
			return this.$route.name;
		},
		userMenu () {
			return [
				{
					text: this.$t('about'),
					action: 'about',
					icon: 'mdi-information-outline',
				},
				{
					text: this.$t('settings'),
					action: 'settings',
					icon: 'mdi-cog-outline',
				},
				{
					text: this.$t('support'),
					action: 'openEmail',
					icon: 'mdi-email-outline',
				},
				{
					text: this.$t('signout'),
					action: 'signout',
					icon: 'mdi-exit-to-app',
				},
			];
		},
		getImageForRole () {
			switch (this.roleName) {
				case 'DOCTOR':
					return this.doctorBlack;
				case 'NURSE':
					return this.nurseBlack;
				case 'HOSPITAL_ADMIN':
					return this.profileSettingsBlack;
				case 'SYSTEM_ADMIN':
					return this.profileSettingsBlack;
				default:
					return this.profileSettingsBlack;
			}
		},
	},
	methods: {
		...mapMutations({
			setDrawer: 'SET_DRAWER',
		}),
		openPDF () {
			const pdfURL = 'https://www.wellnessmetric.net/wmWebManual.pdf';
			window.open(pdfURL, '_blank');
		},
		testHeight () {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return window.innerHeight - 320;
				case 'sm':
					return window.innerHeight - 300;
				case 'md':
					return window.innerHeight - 300;
				case 'lg':
					return window.innerHeight - 280;
				case 'xl':
					return window.innerHeight - 280;
				default:
					return 0;
			}
		},
		selected (item) {
			localStorage.setItem('unit', item);
			switch (item) {
				case 'metric':
					this.chosenUnit = 'metric';
					break;
				case 'imperial':
					this.chosenUnit = 'imperial';
					break;
			}
		},
		signout () {
			this.$router.push({ name: 'Login' });
		},
		redirect (item) {
			switch (item.action) {
				case 'about':
					if (this.$i18n.locale === 'en') {
						window.open('https://www.wellnessmetric.net', '_blank');
					} else {
						window.open('https://www.wellnessmetric.net', '_blank');
						// TODO
						// implementing es webpage
						// window.open(`https://www.wellnessmetric.net/${this.$i18n.locale}`, '_blank');
					}
					break;
				case 'settings':
					this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
						updateDrawer: true,
						page2: 'settings',
					});
					break;
				case 'signout': {
					// we check for the last patient that was opened on patient details page
					// and if we have started tracking time for that patient
					// we call timetracking/stoptrackingwithpatient, before signing out
					// the id of the last patient that was opened on patient details page
					if (this.detailedUser !== null) {
						const patientId = this.detailedUser?.userData.id;
						if ([3, 4, 7].includes(this.authUser.roleData.id)) {
							const getTimeTrackingBody = {
								PatientId: patientId,
							};
							this.$store.dispatch('timetracking/getNotFinishedWithPatient', getTimeTrackingBody).then(() => {
								if (this.startTimeTrackingInfo.data.length === 0) {
									this.signout();
									return;
								}
								const stopTimeTrackingBody = {
									trackingId: this.startTimeTrackingInfo.data[0].id,
								};
								this.$store.dispatch('timetracking/stoptrackingwithpatient', stopTimeTrackingBody).then(() => {
									this.signout();
								});
							});
						} else {
							this.signout(); // for other roles just signout
						}
					} else {
						this.signout();
					}

					// this.signout();
					break;
				}
				case 'openPDF':
					this.openPDF();
					break;
				case 'openEmail':
					window.open('mailto:support@wellnessmetric.net', '_blank');
					break;
				default:
					break;
			}
		},
	},
};
</script>
